module.exports = __webpack_public_path__ + "assets/3282aa825fdc7fa132613943ce4d9fca.png";